import React, { memo } from "react";
import { UpcomingCarCard } from "GlobalComponent/Card/UpcomingCarCard";
import CarouselContainer from "./CarouselContainer";
import PropTypes from "prop-types";

const propTypes = {
  data: PropTypes.arrayOf(UpcomingCarCard.propTypes.data).isRequired,
  platForm: PropTypes.object.isRequired,
  hasViewAllCard: PropTypes.bool,
  containerClassName: PropTypes.string,
  slidesPerView: PropTypes.number,
};

const UpcomingCarCarousel = memo(function UpcomingCarCarousel({
  data,
  platForm,
  containerClassName,
  showNotifyMe = false,
  slidesPerView = 2,
}) {
  if (!data || data.length < 1) {
    return null;
  }
  const isSingleCard = data.length === 1;
  const cardList = data.map(upcomingCar => (
    <UpcomingCarCard
      testingId="upcoming-car-card"
      data={upcomingCar}
      isSingleCard={isSingleCard}
      key={`upcoming-car-${upcomingCar.modelId}`}
      uniqueKey={`upcoming-car-${upcomingCar.modelId}`}
      showNotifyMe={showNotifyMe}
    />
  ));

  return (
    <CarouselContainer
      className={containerClassName}
      platForm={platForm}
      data-testing-id="upcoming-cars-carousel"
      slidesPerView={slidesPerView}
    >
      {cardList}
    </CarouselContainer>
  );
});

UpcomingCarCarousel.propTypes = propTypes;
UpcomingCarCarousel.displayName = "UpcomingCarCarousel";

export default UpcomingCarCarousel;
